import 'common/index';
import '../src/signup/signup.scss';